<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item prop="sellerName" label="开票方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="品番号：">
        <el-input v-model="dataForm.productCode" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="SKU：">
        <el-input v-model="dataForm.skuCode" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="品名：">
        <el-input v-model="dataForm.productName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="颜色：">
        <el-input v-model="dataForm.productColor" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="规格：">
        <el-input v-model="dataForm.productSize" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="幅宽：">
        <el-input v-model="dataForm.productAttr1" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="克重：">
        <el-input v-model="dataForm.productAttr2" size="mini" clearable type="text"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">查询</el-button>
      </el-form-item>
      <el-form-item>
        <FileLink file-type="back" type="warning" file-url="/erp/export/receipt-detail" :params="dataForm">导出EXCEL
        </FileLink>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/erp/receipt/detail/page" api-version="v2" :before-table-binding="beforeTableBinding"
                :query-form="dataForm" :summaries-column="['count','totalAmount']" :auto-load="false">
      <el-table-column prop="orderCode" label="订单编号" align="center" header-align="center" fixed="left">
      </el-table-column>
      <el-table-column prop="receiptCode" label="发票号" align="center" header-align="center" fixed="left">
      </el-table-column>
      <el-table-column prop="sellerName" label="开票方" align="center" header-align="center"
                       :formatter="$c.companyNameFormatter" fixed="left">
      </el-table-column>
      <el-table-column prop="product.code" label="品番号" min-width="90" align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="product.skuCode" label="SKU" min-width="90" align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="product.name" label="品名" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.color" label="颜色" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.size" label="规格" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.attr1" label="幅宽" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.attr2" label="克重" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.nameZh" label="中文品名" min-width="120" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="price" width="100" label="单价" align="center" header-align="center" fixed="right">
      </el-table-column>
      <el-table-column prop="count" width="100" label="数量" align="center" header-align="center" fixed="right">
      </el-table-column>
      <el-table-column prop="totalAmount" width="100" label="金额" align="center" header-align="center" fixed="right">
      </el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'
import FileLink from '@/components/FileLink.vue'
export default {
  name: 'PayDetailTable',
  mixins: [SweetTable],
  props: {
    receiptType: {
      type: String,
      default: 'make',//make:加工费发票，purchase:采购发票
      required: true
    }
  },
  components:{FileLink},
  data () {
    return {
      dataForm: {
        sellerName: '',
        receiptCode: '',
        orderCode: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        receiptType: ''
      },
    }
  },
  watch: {
    receiptType: {
      handler: function (val) {
        this.dataForm.receiptType = val
        this.reload()
      },
      immediate: true
    }
  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(row => {

        try {
          row.totalAmount = new BigNumber(row.count).multipliedBy(row.price).toFixed(2)
        } catch (e) {
          console.log(e)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
